import React, { useState, useEffect } from 'react'
import strings from '../../strings/strings.json'
import styles from './vulns_waiting.module.css'
import Lottie from 'react-lottie'
import waiting from '../../../public/assets/animation/waiting.json'
import Api from '../../../pages/api/api'
import CustomModal from '../../modules/cutom_modal/custom_modal'
import { useDispatch, useSelector } from 'react-redux'
import * as generalAction from '../../redux/action/general_action'

let emailTypingTimer = null
export default function VulnsWaiting(props) {

    const [isOpenModal, setIsOpenModal] = useState(false)
    const [isModalLoading, setIsModalLoading] = useState(false)
    const selector = useSelector(state => state)
    const dispatch = useDispatch()

    useEffect(() => {
        return () => {
            clearTimeout(emailTypingTimer)
        }
    }, [])


    const runAnimaion = (json) => {
        const defaultOptions = {
            loop: true,
            autoplay: true,
            animationData: json,
            rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
        }
        return (
            <Lottie
                options={defaultOptions}
                height={150}
                width={150}
                isStopped={false}
                isPaused={false} />
        )
    }



    const clickHandler = (val) => {
        setIsModalLoading(true)
        Api.vulnsNotification({
            "hash": props.hash,
            "email": val
        })
            .then(result => {
                dispatch(generalAction.setUploaderEmail(true))
                setIsOpenModal(false)
                setIsModalLoading(false)
                props.setSnack(true, "success", strings.general_successOperation)
            })
            .catch(err => {
                setIsModalLoading(false)
                props.setSnack(true, "error", strings.general_faildOperation)
            })
    }


    return (
        <div>
            <div className={styles.container}>
                {
                    runAnimaion(waiting)
                }
                <span className={styles.title}>{strings.general_waiting}</span>
                <span className={styles.subTitle}>{strings.fileDetail_longTime}</span>
                {
                    (!selector.general_reducer.email_exist) &&
                    <div className={styles.followUpContainer}>
                        <span>{strings.fileDetail_followUp}</span>
                        <span>
                            <a className={styles.enterWord} onClick={() => setIsOpenModal(true)} href="###">وارد</a>
                            <span>{strings.fileDetail_followUpLastWord}</span>
                        </span>
                    </div>
                }
            </div>
            <CustomModal
                openModal={isOpenModal}
                ModalStateHandler={(value) => setIsOpenModal(value)}
                title={strings.fileDetail_followUpEnd}
                subTitle={strings.fileDetail_followUpSubtitle}
                confirmClicked={(val) => clickHandler(val)}
                isModalLoading={isModalLoading}
            />
        </div>
    )
}